module.exports = __webpack_public_path__ + "img/tab51.29d6cccb.png";